export default __webpack_public_path__ + "static/media/logoKKahsh.62e6818d.svg";